import Day from './Day';
import I18n from '../../../config/i18n';

export default function DayNames(): JSX.Element {
  return (
    <div className="calendar-week-names">
      {['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day) => (
        <Day key={day} disabled>
          {I18n.t(`days_short.${day}`)}
        </Day>
      ))}
    </div>
  );
}
